/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Filter: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M22.5 4.5H16.5C15.6 4.5 15 5.1 15 6C15 6.9 15.6 7.5 16.5 7.5H22.5C23.4 7.5 24 6.9 24 6C24 5.1 23.4 4.5 22.5 4.5Z' fill='currentColor' />
    <path
      d='M7.5 1.5C5.55 1.5 3.9 2.85 3.3 4.5C3.15 4.5 3.15 4.5 3 4.5H1.5C0.6 4.5 0 5.1 0 6C0 6.9 0.6 7.5 1.5 7.5H3C3.15 7.5 3.15 7.5 3.3 7.5C3.9 9.15 5.55 10.5 7.5 10.5C10.05 10.5 12 8.55 12 6C12 3.45 10.05 1.5 7.5 1.5Z'
      fill='currentColor'
    />
    <path d='M1.5 19.5H7.5C8.4 19.5 9 18.9 9 18C9 17.1 8.4 16.5 7.5 16.5H1.5C0.6 16.5 0 17.1 0 18C0 18.9 0.6 19.5 1.5 19.5Z' fill='currentColor' />
    <path
      d='M22.5 16.5H21C20.85 16.5 20.85 16.5 20.7 16.5C20.1 14.7 18.45 13.5 16.5 13.5C13.95 13.5 12 15.45 12 18C12 20.55 13.95 22.5 16.5 22.5C18.45 22.5 20.1 21.15 20.7 19.5C20.85 19.5 20.85 19.5 21 19.5H22.5C23.4 19.5 24 18.9 24 18C24 17.1 23.4 16.5 22.5 16.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
